<template>
  <div id="newsListBox" class="box_n">
    <div class="news_nav">
      <div class="news_center">
        <div class="news_cnt">
          <div class="news_lft">
            <img src="@/assets/images/zx_ico_1.png" alt="" />
            <span>{{ lange == "ch" ? nav1.ch : nav1.en }}</span>
          </div>
          <div class="news_rgt">
            <span
              v-for="(item, index) in NavList"
              :key="index"
              @click="clcikNavNews(index, item.id)"
              :class="indexNav == index ? 'wow bounceInRight animated addBg' : 'wow bounceInRight animated'"
               :data-wow-delay="0.2 * index + 's'"
              >{{ lange == "ch" ? item.cnName : item.enName }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="news_center">
      <div class="news_list_box">
        <div class="news_list_left">
          <!---->
          <div class="lsCnt_1">
            <div
              class=" news_ls_box"
              v-for="(item, index) in NewsList"
              :key="index"
              v-if="index <= numIndex"
            >
              <div class="news_ls_1">
                <span class="n_span_1">
                  {{ lange == "ch" ? item.cnTitle : item.enTitle }}
                  <small>{{
                    lange == "ch" ? item.cnCategoryName : item.enCategoryName
                  }}</small>
                </span>
              </div>
              <div
                :class="
                  index == 0 ? 'news_ls_2 n_ls_right' : 'news_ls_2 n_ls_left'
                "
              >
                <span>{{ item.n + "-" + item.r }}</span>
                <span
                  :style="
                    'background-image:url(' +
                    require('../../../assets/images/zx_ico_2.png') +
                    ')'
                  "
                  >{{ item.visitorsNum }}</span
                >
              </div>
              <div
                class="news_ls_3"
                v-html="lange == 'ch' ? item.cnDetailTxt : item.enDetailTxt"
              ></div>
              <div class="news_ls_4">
               <div v-if="item.imgFiles">
                  <div
                  class="news_ls_4_1"
                  :style="
                    'background-image:url(' + item.imgFiles + ');width:100%;'
                  "
                  v-if="index == item.nbr"
                ></div>
               </div>
                <!-- <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-around;
                  "
                  v-if="index == 4 || index == 6"
                >
                  <div
                    class="news_ls_4_2"
                    v-for="(itimg, inimg) in item.img"
                    :key="inimg"
                    :style="'background-image:url(' + itimg + ');width:49%;'"
                  ></div>
                </div> -->
              </div>
              <div class="news_ls_5"><span></span></div>
              <div class="news_ls_6">
                <router-link
                  :to="'/Details?id=' + item.id"
                  :style="
                    'background-image:url(' +
                    require('../../../assets/images/zx_ico_3.png') +
                    ')'
                  "
                  >{{
                    lange == "ch" ? lookdetail.ch : lookdetail.en
                  }}</router-link
                >
              </div>
            </div>
          </div>
          <!---->
        </div>
        <div class="news_list_center">
          <!---->
          <div class="lsCnt_2">
            <div
              class="news_ls_box"
              v-for="(item, index) in NewsList"
              :key="index"
              v-if="index > numIndex && index <= numIndex * 2"
            >
              <div class="news_ls_1">
                <span class="n_span_1">
                  {{ lange == "ch" ? item.cnTitle : item.enTitle }}
                  <small>{{
                    lange == "ch" ? item.cnCategoryName : item.enCategoryName
                  }}</small>
                </span>
              </div>
              <div
                :class="
                  index == numIndex * 1 + 1 || index == 2 * numIndex
                    ? 'news_ls_2 n_ls_right'
                    : 'news_ls_2 n_ls_left'
                "
              >
                <span>{{ item.n + "-" + item.r }}</span>
                <span
                  :style="
                    'background-image:url(' +
                    require('../../../assets/images/zx_ico_2.png') +
                    ')'
                  "
                  >{{ item.visitorsNum }}</span
                >
              </div>
              <div
                class="news_ls_3"
                v-html="lange == 'ch' ? item.cnDetailTxt : item.enDetailTxt"
              ></div>
              <div class="news_ls_4">
                <!-- <div
                  class="news_ls_4_1"
                  :style="
                    'background-image:url(' + item.img[0] + ');width:100%;'
                  "
                  v-if="index == 0"
                ></div> -->
                <!-- item.nbr -->
                <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-around;
                  "
                  v-if="index == numIndex * 1 + 1 || index == 2 * numIndex"
                >
                  <div
                    class="news_ls_4_2"
                    :style="
                      'background-image:url(' +
                      item.imgFiles +
                      ');width:48%;padding-top:24%;'
                    "
                  ></div>
                  <div
                    class="news_ls_4_2"
                    :style="
                      'background-image:url(' +
                      item.imgFiles2 +
                      ');width:48%;padding-top:24%;'
                    "
                  ></div>
                </div>
              </div>
              <div class="news_ls_5"><span></span></div>
              <div class="news_ls_6">
                <router-link
                  :to="'/Details?id=' + item.id"
                  :style="
                    'background-image:url(' +
                    require('../../../assets/images/zx_ico_3.png') +
                    ')'
                  "
                  >{{
                    lange == "ch" ? lookdetail.ch : lookdetail.en
                  }}</router-link
                >
              </div>
            </div>
          </div>
          <!---->
        </div>
        <div class="news_list_right">
          <!---->
          <div class="lsCnt_3">
            <div
              class="news_ls_box"
              v-for="(item, index) in NewsList"
              :key="index"
              v-if="index > 2 * numIndex"
            >
              <div class="news_ls_1">
                <span class="n_span_1">
                  {{ lange == "ch" ? item.cnTitle : item.enTitle }}
                  <small>{{
                    lange == "ch" ? item.cnCategoryName : item.enCategoryName
                  }}</small>
                </span>
              </div>
              <div
                :class="
                  index == NewsList.length * 1 - 1
                    ? 'news_ls_2 n_ls_right'
                    : 'news_ls_2 n_ls_left'
                "
              >
                <span>{{ item.n + "-" + item.r }}</span>
                <span
                  :style="
                    'background-image:url(' +
                    require('../../../assets/images/zx_ico_2.png') +
                    ')'
                  "
                  >{{ item.visitorsNum }}</span
                >
              </div>
              <div
                class="news_ls_3"
                v-html="lange == 'ch' ? item.cnDetailTxt : item.enDetailTxt"
              ></div>
              <div class="news_ls_4">
                <div v-if="item.imgFiles">
                  <div
                    class="news_ls_4_1"
                    :style="
                      'background-image:url(' + item.imgFiles + ');width:100%;'
                    "
                    v-if="index == NewsList.length * 1 - 1"
                  ></div>
                </div>
                <!-- item.nbr -->
                <!-- <div
                  style="
                    width: 100%;
                    display: flex;
                    justify-content: space-around;
                  "
                  v-if="index == numIndex * 1 + 1 || index == 2 * numIndex"
                >
                  <div
                    class="news_ls_4_2"
                    v-for="(itimg, inimg) in item.img"
                    :key="inimg"
                    :style="'background-image:url(' + itimg + ');width:49%;'"
                  ></div>
                </div> -->
              </div>
              <div class="news_ls_5"><span></span></div>
              <div class="news_ls_6">
                <router-link
                  :to="'/Details?id=' + item.id"
                  :style="
                    'background-image:url(' +
                    require('../../../assets/images/zx_ico_3.png') +
                    ')'
                  "
                  >{{
                    lange == "ch" ? lookdetail.ch : lookdetail.en
                  }}</router-link
                >
              </div>
            </div>
          </div>
          <!---->
        </div>
      </div>
    </div>
    <div class="loading_box" v-if="loading">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
import { newsFenlei, newsList } from "@/api/index";
export default {
  name: "NewsList",
  components: {},
  computed: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
      indexNav: 0,
      nav1: {
        ch: "选择您想浏览的话题",
        en: "Select the topic you want to browse",
      },
      NavList: [], //导航
      NewsList: [], //内容列表
      lookdetail: {
        ch: "查看详情",
        en: "View details",
      },
      numIndex: 3,
      bodyHeight: "",
      pageNum: 1,
      navId: "",
      loading: false,
      listLoading: false,
    };
  },
  created() {
    var _this = this;
    //滚动条滚到顶部
    this.$BackTop();
    this.$nextTick(() => {
      _this.newsApiFunc(true); //导航
      _this.listenerFunction();
      //_this.newsListFunc(_this.navId); //列表
    });
  },
  mounted() {},
  beforeDestroy() {
    //移除监听滚动条事件
    document.removeEventListener("scroll", this.handleScroll, true); //  离开页面清除（移除）滚轮滚动事件
  },
  methods: {
    listenerFunction(e) {
      //滚动条事件
      document.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件
    },
    handleScroll() {
      //滚动距离
      var _this = this;
      var bodyHeight =
        document.body.offsetHeight * 1 - window.innerHeight - 150; //不需要一定完全触底.
      //console.info("window.pageYOffset="+window.pageYOffset +"   bodyHeight = "+ bodyHeight);
      if (window.pageYOffset >= bodyHeight) {
        _this.newsListFunc(_this.navId); //列表
      }
    },
    clcikNavNews(index, id) {
      if (this.loading) {
        return;
      }
      this.loading = true;
      //导航点解事件
      var _this = this;
      this.indexNav = index;
      this.listLoading = true;
      this.navId = id; //分类id
      this.$nextTick(() => {
        var params = {
          category: id || "",
          pageNum: 1,
        };
        this.pageNum = 1; //重置页数
        newsList(params)
          .then((response) => {
            var arr = response.data.list;
            for (var i = 0; i < arr.length; i++) {
              arr[i].n = this.timestampToTime(arr[i].showTime, "n");
              arr[i].r = this.timestampToTime(arr[i].showTime, "r");
            }
            this.numberFunc(arr);
            this.NewsList = arr;
            //_this.listenerFunction();
            this.$nextTick(() => {
              //滚动条滚到顶部
              //this.$BackTop();
            });
            _this.loading = false;
            if(arr.length <  response.data.pageSize){
              _this.listLoading = true;
            }else{
              _this.listLoading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      });
    },
    numberFunc(a) {
      var arr = [];
      for (var i = 0; i < a.length; i++) {
        a[i].nbr = null;
      }
      for (var i = 0; i < a.length; i++) {
        if (10 * i < a.length) {
          a[10 * i].nbr = 10 * i;
        }
      }
      this.numIndex = parseInt(a.length / 3);
    },

    newsApiFunc(isFirst) {
      let _this = this;
      //新闻分类导航
      newsFenlei()
        .then((response) => {
          _this.NavList = response.data;
          _this.NavList.unshift({ cnName: "全部", enName: "All" });
          //if (isFirst) {
          //  _this.clcikNavNews(_this.indexNav);
          //}
        })
        .catch((error) => {
          console.log(error);
        });
    },
    newsListFunc(id) {
      var _this = this;
      if (_this.listLoading) {
        return;
      }
      _this.listLoading = true;
      //新闻列表
      var ls = this.NewsList;
      var pageNum = _this.pageNum++;
      var params = {
        category: id || -1,
        pageNum: pageNum || 1,
      };
      //_this.listenerFunction();
      newsList(params)
        .then((response) => {
          var arr = response.data.list;
          for (var i = 0; i < arr.length; i++) {
            arr[i].n = this.timestampToTime(arr[i].showTime, "n");
            arr[i].r = this.timestampToTime(arr[i].showTime, "r");
          }
          this.numberFunc(ls.concat(arr));
          this.NewsList = ls.concat(arr);
          this.$nextTick(() => {});
          if(arr.length <  response.data.pageSize){
            _this.listLoading = true;
            //document.removeEventListener("scroll", this.handleScroll, true); //  离开页面清除（移除）滚轮滚动事件
          }else{
            _this.listLoading = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    timestampToTime: function (timestamp, b) {
      //时间戳转换，日期
      var date = new Date(
        timestamp.toString().length < 13 ? timestamp * 1000 : timestamp * 1
      ); //时间戳为10位需*1000，时间戳为13位的话不需乘1000 用 乘以1
      var Y = date.getFullYear() + "";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m = date.getMinutes() + ":";
      var s = date.getSeconds();
      // return Y + M + D; //+h+m+s;
      if (b == "n") {
        return Y;
      } else {
        return M + D;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box_n {
  width: 100%;
  display: block;
  position: relative;
}
.news_center {
  width: 81.25%;
  display: block;
  margin: 0 auto;
}
.news_nav {
  width: 100%;
  display: block;
  position: relative;
  border-bottom: 1px solid #e9e9eb;
}
.news_cnt {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 50px 0 30px 0;
}
.news_lft {
  /* width: 100px; */
  display: block;
  position: relative;
}
.news_lft > img {
  width: 25px;
  height: 29px;
  display: block;
  position: absolute;
  top: 0;
  left: -29px;
}
.news_lft > span {
  font-size: 18px;
  color: #bda67d;
  line-height: 29px;
}
.news_rgt {
  width: 80%;
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  font-family: shsm, shsb,'Avenir', Helvetica, Arial, sans-serif;
}
.news_rgt > span {
  font-size: 16px;
  color: #bda67d;
  display: block;
  border: 1px solid #bda67d;
  border-radius: 30px;
  padding: 5px 20px;
  margin-right: 3%;
  margin-bottom: 14px;
  cursor: pointer;
}
.addBg {
  background-color: #bda67d;
  color: #fff !important;
}
/*ls*/
.news_list_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.news_list_left,
.news_list_center,
.news_list_right {
  display: block;
}
.news_list_left,
.news_list_right {
  width: 40%;
}
.news_list_center {
  width: 60%;
  border-left: 1px solid #e9e9eb;
  border-right: 1px solid #e9e9eb;
}

.news_ls_box {
  width: 100%;
  display: block;
  margin: 60px 0 80px 0;
}
.news_ls_1 {
  width: 100%;
  display: block;
  /*word-break: break-all;111*/
}
.n_span_1 {
  font-size: 18px;
  font-weight: bold;
  color: #02182c;
  display: block;
  position: relative;
}
.n_span_1 > small {
  font-size: 12px;
  background-color: #f7f7f7;
  color: #a7a5a5;
  border-radius: 20px;
  padding: 2px 14px;
  font-weight: 400;
  display: inline-block;
  line-height: initial;
}
.news_ls_2 {
  width: 100%;
  display: flex;
  margin: 26px 0;
}
.news_ls_2 > span {
  font-size: 12px;
  color: #7a7a7a;
}
.news_ls_2 > span:nth-child(1) {
  display: block;
  padding-right: 30%;
}
.news_ls_2 > span:nth-child(2) {
  width: 23px;
  height: 16px;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: 17px 10px;
  padding-left: 28px;
  display: block;
}
.n_ls_right {
  justify-content: space-between;
}
.n_ls_left {
  justify-content: start;
}
.news_ls_3 {
  width: 100%;
  /* min-height: 110px; */
  font-size: 14px;
  color: #7a7a7a;
  line-height: 22px;
  /*word-break: break-all;111*/
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  overflow: hidden;
  margin-bottom: 0px;
}
.news_ls_4 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 0 0 14px 0;
}
.news_ls_4_1 {
  padding-top: 40%;
  display: block;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.news_ls_4_2 {
  padding-top: 24%;
  display: block;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}
.news_ls_5 {
  width: 100%;
  height: 4px;
  display: block;
  background-color: #e9e9e9;
}
.news_ls_5 > span {
  width: 120px;
  height: 4px;
  display: block;
  background-color: #bda67d;
}
.news_ls_6 {
  width: 100%;
  display: block;
  margin-top: 4px;
}
.news_ls_6 > a {
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 23px 14px;
  padding-right: 25px;
  font-size: 16px;
  color: #bda67d;
}
.lsCnt_1,
.lsCnt_2,
.lsCnt_3 {
  width: 90%;
  display: block;
}
.lsCnt_1 {
  margin-right: 10%;
}
.lsCnt_2 {
  margin: 0 5%;
}
.lsCnt_3 {
  margin-left: 10%;
}
.loading_box {
  width: 100%;
  height: 26px;
  display: block;
  position: absolute;
  bottom: -30px;
  text-align: center;
}
.loading_box > i {
  font-size: 26px;
  color: #aaa;
}
@media only screen and (max-width: 1440px) {
  .news_center {
    width: 90%;
  }
}

@media only screen and (max-width: 768px) {
  .news_list_box {
    flex-wrap: wrap;
  }
  .news_list_left,
  .news_list_center,
  .news_list_right {
    width: 100%;
    border: 0;
  }
  .lsCnt_1,
  .lsCnt_2,
  .lsCnt_3 {
    width: 100%;
    margin: 0;
  }

  .news_cnt {
    flex-wrap: wrap;
  }
  .news_lft {
    margin-bottom: 20px;
  }
  .news_center {
    width: 80%;
  }
  .news_rgt {
    width: 100%;
  }
}
@media only screen and (max-width: 425px) {
  .news_center {
    width: 90%;
  }
  .news_lft > span {
    font-size: 14px;
    padding-left: 26px;
    line-height: 24px;
  }
  .news_lft > img {
    width: 20px;
    height: 24px;
    left: 0;
  }
  .news_cnt {
    margin: 0px 0;
  }
  .news_rgt > span {
    font-size: 14px;
    padding: 2px 10px;
  }
  .news_ls_box {
    width: 100%;
    display: block;
    margin: 20px 0;
  }
  .n_span_1 {
    font-size: 14px;
  }
  .news_ls_2 {
    margin: 10px 0;
  }
  .news_ls_3 {
    font-size: 12px;
    line-height: 20px;
  }
  .news_ls_6 > a {
    font-size: 12px;
    background-size: 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/LatestInformation/component/NewsList.vue